import { ProductionStatus, Shipment } from "../../../../reducers/uploadedBoard";
import { ShipmentsRowContainer } from "./ShipmentsStyles";
import { InputLabel } from "../../../../constants/Styles";
import { leadTimeInfoString } from "../../../../utils/valueFormatting";
import Link from "next/link";

export default function CustomerShipmentSummary({
  shipment,
}: {
  shipment: Shipment;
}) {
  return (
    <ShipmentsRowContainer>
      <div>
        <InputLabel>Number of boards</InputLabel>
        <div>{shipment.num_boards.toLocaleString()}</div>
      </div>
      <div>
        <InputLabel>Ship date</InputLabel>
        <div>
          {leadTimeInfoString(
            shipment.lead_time_days || shipment.base_lead_time_days,
            shipment.ship_date,
          )}
        </div>
      </div>

      {shipment.delivery_info.shipping_rate !== null &&
        shipment.delivery_info.shipping_rate.tracking_url && (
          <Link
            href={shipment.delivery_info.shipping_rate.tracking_url}
            target={"_blank"}
          >
            Track shipment
          </Link>
        )}
      {shipment.production_status == ProductionStatus.MANUFACTURED &&
        shipment.delivery_info.pickup_info !== null &&
        "Your order is ready for pickup"}
    </ShipmentsRowContainer>
  );
}
